var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-ability-ui-com-timeRange"},[_c('el-time-picker',{attrs:{"format":"HH:mm","placeholder":_vm.$t('iftttset.SelecTime')},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }